module.exports = {"610424001":"城关街道","610424101":"薛录镇","610424102":"梁村镇","610424103":"临平镇","610424104":"姜村镇","610424105":"王村镇","610424106":"马连镇","610424107":"阳峪镇","610424108":"峰阳镇","610424109":"注泔镇","610424110":"灵源镇","610424111":"阳洪镇","610424112":"梁山镇","610424113":"周城镇","610424114":"新阳镇","610424115":"大杨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610424.json
// module id = 2811
// module chunks = 0